const Loading = () => {
  return (
    <>
      <div
        role="status"
        className="spinner-border d-flex justify-content-center align-items-center"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </>
  );
};

export default Loading;
